export default __webpack_public_path__ + "static/media/screen_google_sheets_03.2897eac7.png";